import { NotificationBadge } from '@/features/shared/components/NotificationBadge'
import { CartIcon, CartHalloweenIcon } from '@shipt/design-system-icons'
import { useQueryAllShoppingCarts } from '@/features/shop/services/Carts/queries'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicGlobalHomePageCartDrawer } from '@/features/shop/components/Drawer/GlobalHomePageCartDrawer/DynamicGlobalHomePageCartDrawer'
import { IconButton } from '@shipt/design-system-buttons'
import { useQueryCMSContentAlias } from '@/features/cms/services/CMS/queries'
import { useEffect } from 'react'
import { medallia } from '@/lib/medallia'
import { useUserId } from '@/features/account/services/User/hooks'

export const CartsButton = ({ holidayGHP }: { holidayGHP?: boolean }) => {
  const { data: carts = [] } = useQueryAllShoppingCarts()
  const { openDialog } = useHandleDialog()

  // needed here to load the cache for the drawer
  const isLoggedIn = Boolean(useUserId())
  useQueryCMSContentAlias('global-cart-punch-card', { enabled: isLoggedIn })

  const totalNumCartItems = carts.reduce((sum, cart) => sum + cart.cart.num_items, 0)
  useEffect(() => {
    medallia.setParams({ cart_item_count: totalNumCartItems })
  }, [totalNumCartItems])

  const ariaCartPlurality = carts.length === 1 ? 'cart' : 'carts'
  const ariaLabelText = `${carts.length} ${ariaCartPlurality}. Click to view carts.`

  const handleOnClick = () => {
    trackElementClicked({
      type: 'button',
      content: 'global_cart',
      display_format: 'horizontal_list',
      display_sublocation: 'global_cart (right side)',
    })
    openDialog(DynamicGlobalHomePageCartDrawer)
  }

  return (
    <NotificationBadge surface="inverse" value={totalNumCartItems} ariaContext="carts">
      <IconButton
        icon={holidayGHP ? CartHalloweenIcon : CartIcon}
        variant={holidayGHP ? 'primary' : 'tertiary'}
        surface={holidayGHP ? 'inverse' : undefined}
        size="md"
        onClick={handleOnClick}
        aria-label={ariaLabelText}
      />
    </NotificationBadge>
  )
}
